import { adminServerInstance, helpDeskServerInstance } from "../axios/instances";
import { 
    INSERT_OPERATION_LOG,
    INSERT_OPERATION_LOG_SUCCESS,
    INSERT_OPERATION_LOG_FAIL,
    SEARCH_UNKNOWN_PACKAGE_DATA,
    SEARCH_UNKNOWN_PACKAGE_DATA_SUCCESS,
    SEARCH_UNKNOWN_PACKAGE_DATA_FAIL,
    RESTORE_TO_STATE,
    RESTORE_TO_STATE_SUCCESS,
    RESTORE_TO_STATE_FAIL,
    OAUTH_TOKEN,
    OAUTH_TOKEN_SUCCESS,
    OAUTH_TOKEN_FAIL,
    CHANGE_ORDER_WAREHOUSE,
    CHANGE_ORDER_WAREHOUSE_SUCCESS,
    CHANGE_ORDER_WAREHOUSE_FAIL
 } from './types';

export function insertOperationLog(operation_code, tnos, operator) {   
    return function(dispatch) {
        dispatch({type: INSERT_OPERATION_LOG})
        return adminServerInstance.post("/driver/insertoperationlog", {
            operation_code: operation_code,
            tnos: tnos,
            operator: operator
        })
        .then(({data}) => {
            dispatch({
                type: INSERT_OPERATION_LOG_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: INSERT_OPERATION_LOG_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function oauthToken() {   
    return function(dispatch) {
        dispatch({type: OAUTH_TOKEN})
        return adminServerInstance.post("/oauth/token?version=1", {
            grant_type: 'client_credentials',
            client_id: '100017',
            client_secret: '9ENF0F8goIHptFngABFEIuHaU7loZoTP'
        }).then(({data}) => {
            dispatch({
                type: OAUTH_TOKEN_SUCCESS,
                payload: data.data
            })
            helpDeskServerInstance.defaults.headers.common['Authorization'] = `Bearer ${data.data.access_token}`
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: OAUTH_TOKEN_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function searchUnknownPackageData(tnos, warehouse, batchNo, is_scanned, scan_location){
    return function(dispatch){
        dispatch({type: SEARCH_UNKNOWN_PACKAGE_DATA})
        return helpDeskServerInstance.get(`/business/searchunknownpackagedata?tnos=${tnos}&warehouse=${warehouse}&batch_no=${batchNo}&version=1&local_import=1&is_scanned=${is_scanned}&scan_location=${scan_location}`)
            .then(({data}) => {
                dispatch({
                    type: SEARCH_UNKNOWN_PACKAGE_DATA_SUCCESS,
                    payload: data
                })
                return Promise.resolve(data);
            }).catch(error => {
                dispatch({
                    type: SEARCH_UNKNOWN_PACKAGE_DATA_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function changeOrderWarehouse(tno, warehouse, operator) {
    return function (dispatch) {
        dispatch({ type: CHANGE_ORDER_WAREHOUSE });

        const payload = {
            tnos: tno,
            warehouse: warehouse,
            operator: operator
        };

        return adminServerInstance.post('/driver/changeorderwarehouse', payload)
            .then(({ data }) => {
                dispatch({
                    type: CHANGE_ORDER_WAREHOUSE_SUCCESS,
                    payload: data.data
                });
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: CHANGE_ORDER_WAREHOUSE_FAIL,
                    payload: error
                });
                return Promise.reject(error);
            });
    }
}


export function restoreToState(tno, state, warehouse){
    return function(dispatch){
        dispatch({type: RESTORE_TO_STATE})
        return adminServerInstance.post(`/driver/restoretostate?tno=${tno}&state=${state}&warehouse=${warehouse}&version=1`)
            .then(({data}) => {
                dispatch({
                    type: RESTORE_TO_STATE_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: RESTORE_TO_STATE_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}